
import { Dossier } from "@/models/dossier";
import { CompanyDossierService, IMoveUserDataSetting } from "@/services/company-dossier-service";
import AppSelectDossier from "./DossierEditQuickCreateCopySelectTargetDossier.vue";
import AppSetMoveUserDatas from "./DossierEditQuickCopyCreateMoveUserData.vue";
import AppSpinner from "./DossierEditQuickCopySpinner.vue";
import AppReady from "./DossierEditQuickCopyReady.vue";
import Vue from "vue";
import { Company } from "@/models/company";

export default Vue.extend({
	data(){
		return {
			step: 0,
			targetDossier: null as null | Dossier,
			moveUserDataSettings: [] as IMoveUserDataSetting[],
		};
	},
	props: {
		originalDossier: {
			type: Object as ()=>Dossier,
			required: true
		},
		originalCompany: {
			type: Object as ()=>Company,
			required: true
		}
	},
	computed: {
		cancelText():string{
			if (this.step == 0) {
				return "Anuleren";
			}
			if (this.step == 1){
				return "Vorige";
			}
			return "";
		},
		confirmText(){
			if (this.step == 0) {
				return "Volgende";
			}
			if (this.step == 1) {
				return "Kopie maken";
			}
			return "Sluiten";
		},
		confirmDisabled():boolean{
			if (this.step == 0 && this.targetDossier == null) return true;
			if (this.step == 1){
				for (let i = 0; i < this.moveUserDataSettings.length; i++){
					let setting = this.moveUserDataSettings[i];
					if (setting.toUserId == 0) return true;
					if (setting.fromUserId == 0) return true;
					for (let c = 0; c < i; c++){
						let setting2 = this.moveUserDataSettings[c];
						if (setting.fromUserId == setting2.fromUserId) return true;
						if (setting.toUserId == setting2.toUserId) return true;
					}
				}
			}
			return false;
		}
	},
	watch: {
		targetDossier(newValue:Dossier, oldValue:Dossier){
			console.log("Target dossier changed");
			if (oldValue != null && newValue != null) {
				if (oldValue.id == newValue.id) return;
			}
			this.moveUserDataSettings.splice(0, this.moveUserDataSettings.length);
			if (newValue == null || !newValue.company) return;
			let originalOwnerId = this.originalCompany.ownerId;
			let targetOwnerId = newValue.company.ownerId;
			this.moveUserDataSettings.push({
				fromUserId: originalOwnerId,
				toUserId: targetOwnerId
			});
		}
	},
	methods: {
		previous(){
			if (this.step == 0){
				return this.$emit("close");
			}
			this.step--;
		},
		async next(){
			if (this.step == 0){
				if (!this.targetDossier) return;
				return this.step++;
			}
			if (this.step == 1){
				if (this.targetDossier){
					let msg = `Weet je zeker dat je dossier ${this.originalDossier.name} (${this.originalDossier.id}) 
					wilt kopiëren naar ${this.targetDossier.name} (${this.targetDossier.id})?
					<br>Dossier ${this.originalDossier.name} gaat tijdelijk niet bruikbaar zijn tijdens het kopieeren.
					`;
					msg += "<br>Dit kan niet meer ongedaan worden dus controleer dat je zeker naar het juiste dossier kopieerd!!!!";
					let confirm = await this.$wf.confirm(msg, "Ja", "Nee", "WAARSCHUWING!");
					if (!confirm) return;
					return this.doCopy();
				}
				return;
			}
			this.$emit("close");
		},
		async doCopy(){
			if (this.step == 2) return;
			if (this.targetDossier == null) return;
			this.step = 2;
			try{
				await CompanyDossierService.quickCopyDossier(this.originalDossier.id, this.targetDossier.id, this.moveUserDataSettings);
				this.step = 3;
			}catch(err){
				this.step = 1;
				let error = err as any;
				if (error.message){
					console.error(error.message);
				}
			}
		}
	},
	components: {
		AppSelectDossier,
		AppSetMoveUserDatas,
		AppSpinner,
		AppReady
	}
});
